/**
 * Относительные пути delivery-эндпоинтов основного бэкенда (VITE_API_URL + '/api/').
 * Пути заданы без ведущего слэша — baseURL инстанса api уже содержит '/api/'.
 * Единая точка правки при переводе вызовов со старого сервиса доставки.
 */
export const DELIVERY_ENDPOINTS = {
  // public
  addressCities: 'public/delivery/cities',
  addressesByQuery: 'public/delivery/addresses/by-query',
  addressesByGeo: 'public/delivery/addresses/by-geo',
  pvz: 'public/delivery/pvz',
  calculate: 'public/delivery/calculate',
  // admin
  adminDelivery: (orderUuid: string): string => `admin/delivery/${orderUuid}`,
  adminLabels: (orderUuid: string): string =>
    `admin/delivery/${orderUuid}/labels`,
  adminWaybills: (orderUuid: string): string =>
    `admin/delivery/${orderUuid}/waybills`,
  adminCancel: (orderUuid: string): string =>
    `admin/delivery/${orderUuid}/cancel`,
  adminDelete: (orderUuid: string): string =>
    `admin/delivery/${orderUuid}/delete`,
  adminCalculate: (orderUuid: string): string =>
    `admin/delivery/${orderUuid}/calculate`,
  adminTrackingHistory: (orderUuid: string): string =>
    `admin/delivery/${orderUuid}/tracking-history`
} as const;
